import { useNavigate } from "react-router-dom";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import Button from "@/components/ui/Button";
import { ButtonStyleType, UIComponentSize } from "@/types/shared/uiComponents";

/** Where lasers are managed: the policy's Lasered Claimants tab. */
export const lasersOnPolicyPath = (policyId: string) => `/policies/${policyId}/show/lasered-claimants`;

/**
 * Lasers (standard, contract and conditional) are written only on the policy's
 * Lasered Claimants tab, where the policy is never in doubt (PO 2026-10-07).
 * The claimant page shows them read-only with this link.
 */
export const ManageLasersOnPolicyLink = ({ policyId }: { policyId: string }) => {
  const navigate = useNavigate();
  return (
    <Button
      variant={ButtonStyleType.Text}
      size={UIComponentSize.Small}
      startIcon={<OpenInNewIcon sx={{ fontSize: 16 }} />}
      onClick={(e: React.MouseEvent) => {
        e.stopPropagation();
        void navigate(lasersOnPolicyPath(policyId));
      }}
      data-testid="manage-lasers-on-policy"
    >
      Manage on policy
    </Button>
  );
};
